/* -- Lineup Archive: search, multi-select filters, GSAP flip, modal -- */

/* -- Reduced motion check -- */
var laReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* -- E: Lazy GSAP flip via IntersectionObserver -- */
function laInitFlip(card) {
  if (card.getAttribute('data-flip-init')) return;
  card.setAttribute('data-flip-init', '1');
  if (laReducedMotion) return;
  gsap.set(card, { transformStyle: "preserve-3d", transformPerspective: 1000 });
  var q = gsap.utils.selector(card);
  var front = q(".front");
  var back = q(".back");
  gsap.set(back, { rotationY: -180 });
  var tl = gsap.timeline({ paused: true })
    .to(front, { duration: .5, rotationY: 180 })
    .to(back, { duration: .5, rotationY: 0 }, 0)
    .to(card, { z: 10 }, 0)
    .to(card, { z: 0 }, 0.25);
  card.addEventListener("mouseenter", function() { tl.play(); });
  card.addEventListener("mouseleave", function() { tl.reverse(); });
}

/* E: Lazy init -- only initialize GSAP when cards scroll into view */
var laFlipObserver;
if ('IntersectionObserver' in window) {
  laFlipObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        laInitFlip(entry.target);
        laFlipObserver.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });
  document.querySelectorAll('.lineup-card').forEach(function(card) {
    laFlipObserver.observe(card);
  });
} else {
  gsap.utils.toArray(".lineup-card").forEach(laInitFlip);
}

/* -- Main gallery logic -- */
var lineupGallery = document.querySelector('.lineup-gallery');
if (lineupGallery) {
  var laPanels = lineupGallery.querySelectorAll('.lineup-gallery__panel');
  var allCards = Array.from(lineupGallery.querySelectorAll('.lineup-gallery__panel .lineup-card'));
  var laSection = lineupGallery.closest('section');
  var laFeatured = lineupGallery.querySelector('.lineup-gallery__featured');

  /* D: Read cross-link URL from data attribute */
  var laPosterUrl = lineupGallery.getAttribute('data-poster-url') || '/pages/poster-gallery';
  var laPosters = {};
  (function() {
    var el = laSection.querySelector('[data-la-posters]');
    if (el) { try { laPosters = JSON.parse(el.textContent); } catch (err) { laPosters = {}; } }
  })();

  var laSearch = laSection.querySelector('[id^="la-search"]');
  var laResultsCount = laSection.querySelector('[id^="la-results-count"]');
  var laClearBtn = laSection.querySelector('[id^="la-clear"]');
  var laNoResults = laSection.querySelector('[id^="la-no-results"]');
  var laFilteredGrid = laSection.querySelector('[id^="la-filtered-grid"]');
  var laFilterToggle = laSection.querySelector('[id^="la-filter-toggle"]');
  var laFilterDrawer = laSection.querySelector('[id^="la-filter-drawer"]');
  var laFilterBadge = laSection.querySelector('[id^="la-filter-badge"]');

  /* Multi-select filter elements */
  var laFilterYear = laSection.querySelector('[id^="la-filter-year"]');
  var laFilterEvent = laSection.querySelector('[id^="la-filter-event"]');
  var laFilterArtist = laSection.querySelector('[id^="la-filter-artist"]');

  /* -- Default to most recent year -- */
  var defaultYear = laPanels.length > 0 ? laPanels[0].getAttribute('data-year') : '';

  /* No panels active by default - featured row is the landing view */
  laPanels.forEach(function(p) {
    p.classList.remove('active');
  });

  /* -- Filter toggle -- */
  laFilterToggle.addEventListener('click', function() {
    var isOpen = laFilterDrawer.classList.toggle('open');
    laFilterToggle.classList.toggle('active', isOpen);
  });

  /* -- Multi-select dropdown logic -- */
  function setupMultiSelect(container) {
    var trigger = container.querySelector('.la-multi__trigger');
    var dropdown = container.querySelector('.la-multi__dropdown');
    var label = container.getAttribute('data-label');

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      laSection.querySelectorAll('.la-multi.open').forEach(function(el) {
        if (el !== container) el.classList.remove('open');
      });
      container.classList.toggle('open');
    });

    dropdown.addEventListener('change', function() {
      updateTriggerLabel(container, label);
      laApplyFilters();
    });

    dropdown.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  }

  function updateTriggerLabel(container, label) {
    var checked = container.querySelectorAll('input[type="checkbox"]:checked');
    var trigger = container.querySelector('.la-multi__trigger');
    var svg = '<svg viewBox="0 0 12 12" width="10" height="10"><path d="M2.5 4.5L6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    if (checked.length === 0) {
      trigger.innerHTML = label + ' ' + svg;
    } else {
      trigger.innerHTML = label + ' <span class="la-multi__count">' + checked.length + '</span> ' + svg;
    }
  }

  function getCheckedValues(container) {
    var vals = [];
    container.querySelectorAll('input[type="checkbox"]:checked').forEach(function(cb) {
      vals.push(cb.value);
    });
    return vals;
  }

  /* Close dropdowns on outside click */
  document.addEventListener('click', function() {
    laSection.querySelectorAll('.la-multi.open').forEach(function(el) {
      el.classList.remove('open');
    });
  });

  /* -- Helper: decode HTML entities -- */
  function decodeEntities(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  /* -- Helper: escape HTML to prevent XSS in modal -- */
  function laEscapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* -- Populate filter dropdowns from card data -- */
  var eventSet = {};
  var artistSet = {};
  allCards.forEach(function(c) {
    var evType = c.getAttribute('data-event-type');
    if (evType) eventSet[evType] = true;

    var dayDataStr = c.getAttribute('data-day-data');
    if (dayDataStr) {
      try {
        var dayData = JSON.parse(decodeEntities(dayDataStr));
        for (var i = 0; i < dayData.length; i++) {
          var artists = dayData[i].artists;
          if (artists) {
            for (var j = 0; j < artists.length; j++) {
              if (artists[j]) artistSet[artists[j]] = true;
            }
          }
        }
      } catch(e) {}
    }
  });

  function populateMultiSelect(container, items, addSearch) {
    var dropdown = container.querySelector('.la-multi__dropdown');
    var sorted = Object.keys(items).sort();

    if (addSearch && sorted.length > 20) {
      var searchInput = document.createElement('input');
      searchInput.type = 'text';
      searchInput.className = 'la-multi__search';
      searchInput.placeholder = 'Search...';
      searchInput.setAttribute('aria-label', 'Filter ' + container.getAttribute('data-label'));
      searchInput.addEventListener('input', function() {
        var q = this.value.toLowerCase();
        var labels = dropdown.querySelectorAll('label');
        labels.forEach(function(lbl) {
          var text = lbl.textContent.toLowerCase();
          lbl.style.display = text.indexOf(q) !== -1 ? '' : 'none';
        });
      });
      searchInput.addEventListener('click', function(e) { e.stopPropagation(); });
      dropdown.appendChild(searchInput);
    }

    sorted.forEach(function(val) {
      var lbl = document.createElement('label');
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.value = val;
      var span = document.createElement('span');
      span.textContent = val;
      lbl.appendChild(cb);
      lbl.appendChild(span);
      dropdown.appendChild(lbl);
    });
  }
  populateMultiSelect(laFilterEvent, eventSet, false);
  populateMultiSelect(laFilterArtist, artistSet, true);

  /* Init multi-selects */
  laSection.querySelectorAll('.la-multi').forEach(setupMultiSelect);

  /* -- Filter state -- */
  var laIsFiltering = false;

  function laCountActiveFilters() {
    var count = 0;
    laSection.querySelectorAll('.la-multi input[type="checkbox"]:checked').forEach(function() { count++; });
    return count;
  }

  function laHasActiveFilters() {
    return (laSearch.value.trim() !== '' || laCountActiveFilters() > 0);
  }

  function laUpdateBadge() {
    var count = laCountActiveFilters();
    if (count > 0) {
      laFilterBadge.textContent = count;
      laFilterBadge.classList.add('visible');
    } else {
      laFilterBadge.classList.remove('visible');
    }
  }

  /* -- Helper: get all artist names from a card -- */
  function getCardArtists(card) {
    var names = [];
    var dayDataStr = card.getAttribute('data-day-data');
    if (dayDataStr) {
      try {
        var dayData = JSON.parse(decodeEntities(dayDataStr));
        for (var i = 0; i < dayData.length; i++) {
          var artists = dayData[i].artists;
          if (artists) {
            for (var j = 0; j < artists.length; j++) {
              if (artists[j]) names.push(artists[j]);
            }
          }
        }
      } catch(e) {}
    }
    return names;
  }

  function laApplyFilters() {
    var query = laSearch.value.trim().toLowerCase();
    var fYears = getCheckedValues(laFilterYear);
    var fEvents = getCheckedValues(laFilterEvent);
    var fArtists = getCheckedValues(laFilterArtist);
    laIsFiltering = laHasActiveFilters();
    laUpdateBadge();

    if (laIsFiltering) {
      laPanels.forEach(function(p) { p.style.display = 'none'; });
      if (laFeatured) laFeatured.style.display = 'none';
      lineupGallery.classList.add('la-filtering');

      laFilteredGrid.innerHTML = '';
      laFilteredGrid.classList.add('active');

      var matchCount = 0;
      allCards.forEach(function(card) {
        var name = (card.getAttribute('data-name') || '').toLowerCase();
        var eventType = card.getAttribute('data-event-type') || '';
        var venue = (card.getAttribute('data-venue') || '').toLowerCase();
        var year = card.getAttribute('data-year') || '';
        var desc = (card.getAttribute('data-description') || '').toLowerCase();
        var cardArtists = getCardArtists(card);
        var artistsLower = cardArtists.map(function(a) { return a.toLowerCase(); });

        var match = true;

        if (query) {
          var textMatch = name.indexOf(query) !== -1 ||
                          venue.indexOf(query) !== -1 ||
                          eventType.toLowerCase().indexOf(query) !== -1 ||
                          desc.indexOf(query) !== -1;
          if (!textMatch) {
            for (var ai = 0; ai < artistsLower.length; ai++) {
              if (artistsLower[ai].indexOf(query) !== -1) { textMatch = true; break; }
            }
          }
          if (!textMatch) match = false;
        }

        if (fYears.length > 0 && fYears.indexOf(year) === -1) match = false;
        if (fEvents.length > 0 && fEvents.indexOf(eventType) === -1) match = false;
        if (fArtists.length > 0) {
          var artistMatch = false;
          for (var fi = 0; fi < fArtists.length; fi++) {
            if (cardArtists.indexOf(fArtists[fi]) !== -1) { artistMatch = true; break; }
          }
          if (!artistMatch) match = false;
        }

        if (match) {
          var clone = card.cloneNode(true);
          clone.removeAttribute('data-flip-init');
          laFilteredGrid.appendChild(clone);
          matchCount++;
        }
      });

      /* E: Use observer for cloned cards too */
      laFilteredGrid.querySelectorAll('.lineup-card').forEach(function(card) {
        if (laFlipObserver) {
          laFlipObserver.observe(card);
        } else {
          laInitFlip(card);
        }
      });
      laResultsCount.textContent = matchCount + ' event' + (matchCount !== 1 ? 's' : '') + ' found';
      laNoResults.style.display = matchCount === 0 ? 'block' : 'none';
      laClearBtn.classList.add('visible');

    } else {
      laFilteredGrid.classList.remove('active');
      laFilteredGrid.innerHTML = '';
      laNoResults.style.display = 'none';
      laClearBtn.classList.remove('visible');
      lineupGallery.classList.remove('la-filtering');

      if (laFeatured) laFeatured.style.display = '';

      laPanels.forEach(function(p) {
        p.style.display = '';
        p.classList.remove('active');
      });

      laResultsCount.textContent = '';
    }
  }

  laResultsCount.textContent = '';

  /* -- Event listeners -- */
  var laDebounceTimer;
  laSearch.addEventListener('input', function() {
    clearTimeout(laDebounceTimer);
    laDebounceTimer = setTimeout(laApplyFilters, 250);
  });

  laClearBtn.addEventListener('click', function() {
    laSearch.value = '';
    laSection.querySelectorAll('.la-multi input[type="checkbox"]:checked').forEach(function(cb) {
      cb.checked = false;
    });
    laSection.querySelectorAll('.la-multi').forEach(function(m) {
      updateTriggerLabel(m, m.getAttribute('data-label'));
    });
    laSection.querySelectorAll('.la-multi__search').forEach(function(inp) {
      inp.value = '';
      inp.dispatchEvent(new Event('input'));
    });
    laApplyFilters();
  });

  /* -- Modal -- */
  var laModal = laSection.querySelector('.lineup-modal-wrapper');

  if (laModal && laModal.closest('main')) {
    document.body.appendChild(laModal);
  }

  var laCapUpper = laModal.classList.contains('modal-caption-upper') ? ' uppercase' : '';
  var laMainBtnClass = laModal.getAttribute('data-main-btn-class') || '';
  var laBtnBold = laModal.getAttribute('data-btn-bold') === 'true';
  function laBtnLabel(t) { return laBtnBold ? '<b>' + t + '</b>' : t; }
  var laSubUpper = laModal.classList.contains('modal-subheading-upper') ? ' uppercase' : '';
  var laModalImg = laModal.querySelector('.lineup-modal-left img');
  var laModalTitle = laModal.querySelector('.lineup-modal-title');
  var laModalDetails = laModal.querySelector('.lineup-modal-details');
  var laModalAction = laModal.querySelector('[id^="lineup-modal-action"]');
  var laCloseBtn = laModal.querySelector('.lineup-modal-close');
  laModal.addEventListener('click', function(e) {
    var b = e.target.closest && e.target.closest('.la-poster-showmore');
    if (!b) return;
    var wrap = b.closest('.lineup-modal-posters');
    if (wrap) { var hid = wrap.querySelectorAll('.la-poster-hidden'); for (var i = 0; i < hid.length; i++) hid[i].classList.remove('la-poster-hidden'); }
    b.remove();
  });
  var laPrevBtn = laModal.querySelector('.lineup-modal-prev');
  var laNextBtn = laModal.querySelector('.lineup-modal-next');
  var laCurrentCards = [];
  var laCurrentIndex = 0;

  function laOpenModal(cards, index) {
    laCurrentCards = Array.from(cards);
    laCurrentIndex = index;
    laRenderModal();
    laModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function laExtractYouTubeId(url) {
    if (!url) return '';
    var match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]+)/);
    return match ? match[1] : '';
  }

  function laRenderModal() {
    var card = laCurrentCards[laCurrentIndex];
    laModalImg.src = card.getAttribute('data-image-url') || card.getAttribute('data-image-thumb') || '';
    laModalImg.alt = card.getAttribute('data-name');
    laModalTitle.textContent = card.getAttribute('data-name');

    var html = '';
    var dates = card.getAttribute('data-dates');
    var venue = card.getAttribute('data-venue');
    var city = card.getAttribute('data-city');
    var artistCount = parseInt(card.getAttribute('data-artist-count') || '0', 10);
    var desc = card.getAttribute('data-description');
    var dayDataStr = card.getAttribute('data-day-data');
    var dayLabelsStr = card.getAttribute('data-day-labels');
    var recapVideo = card.getAttribute('data-recap-video');
    var lineupUrl = card.getAttribute('data-lineup-url');

    if (dates) {
      html += '<div><span class="lineup-modal-detail-label caption-font' + laCapUpper + '">Dates</span><span class="lineup-modal-detail-value body-font">' + laEscapeHtml(dates) + '</span></div>';
    }
    if (venue) {
      var venueDisplay = laEscapeHtml(venue);
      if (city) venueDisplay += ', ' + laEscapeHtml(city);
      html += '<div><span class="lineup-modal-detail-label caption-font' + laCapUpper + '">Venue</span><span class="lineup-modal-detail-value body-font">' + venueDisplay + '</span></div>';
    }
    if (artistCount > 0) {
      html += '<div><span class="lineup-modal-detail-label caption-font' + laCapUpper + '">Artists</span><span class="lineup-modal-detail-value body-font">' + artistCount + ' performers</span></div>';
    }
    if (desc) {
      html += '<div><span class="lineup-modal-detail-label caption-font' + laCapUpper + '">About</span><span class="lineup-modal-detail-value lineup-modal-desc body-font">' + laEscapeHtml(desc) + '</span></div>';
    }

    /* Shop CTA */
    html += '<div class="lineup-modal-shop-cta"><a href="/collections/all" class="lineup-modal-shop-link caption-font' + laCapUpper + '">Shop Artists Like These and More <span>&rsaquo;</span></a></div>';

    /* D: Cross-link to poster gallery using data attribute URL */
    var cardYear = card.getAttribute('data-year');
    var cardEventType = card.getAttribute('data-event-type');
    if (cardYear) {
      var posterParams = '?year=' + encodeURIComponent(cardYear);
      if (cardEventType) posterParams += '&event=' + encodeURIComponent(cardEventType);
      html += '<div class="lineup-modal-shop-cta"><a href="' + laEscapeHtml(laPosterUrl) + posterParams + '" class="lineup-modal-shop-link caption-font' + laCapUpper + '">View Posters from This Event <span>&rsaquo;</span></a></div>';
    }

    /* Individual poster strip (from gallery_posters via the archive index) */
    var evHandle = card.getAttribute('data-event-handle');
    var evPosters = evHandle && laPosters[evHandle];
    if (evPosters && evPosters.length) {
      html += '<div class="lineup-modal-posters"><p class="lineup-modal-posters-heading caption-font' + laCapUpper + '">Posters from this event</p><div class="lineup-modal-posters-grid">';
      evPosters.forEach(function(p, idx) {
        var posterHref = p.u || (laPosterUrl + posterParams);
        html += '<a class="lineup-modal-poster' + (idx >= 8 ? ' la-poster-hidden' : '') + '" href="' + laEscapeHtml(posterHref) + '">' +
          '<img src="' + laEscapeHtml(p.i) + '?width=200" loading="lazy" alt="' + laEscapeHtml(p.b ? p.b + ' poster' : 'Event poster') + '">' +
          (p.b ? '<span class="caption-font' + laCapUpper + '">' + laEscapeHtml(p.b) + '</span>' : '') + '</a>';
      });
      html += '</div>';
      if (evPosters.length > 8) {
        html += '<button type="button" class="la-poster-showmore caption-font' + laCapUpper + '">Show ' + (evPosters.length - 8) + ' More</button>';
      }
      html += '</div>';
    }

    /* Day-by-day lineup */
    if (dayDataStr) {
      try {
        var dayData = JSON.parse(decodeEntities(dayDataStr));
        var dayLabels = {};
        if (dayLabelsStr) {
          try {
            var cleaned = decodeEntities(dayLabelsStr).replace(/=>/g, ':');
            dayLabels = JSON.parse(cleaned);
          } catch(e2) {}
        }

        if (dayData.length > 0) {
          html += '<div class="lineup-modal-days">';
          for (var d = 0; d < dayData.length; d++) {
            var dayNum = dayData[d].day;
            var dayKey = 'day_' + dayNum;
            var dayLabel = dayLabels[dayKey] || ('Day ' + dayNum);
            var artists = dayData[d].artists || [];

            html += '<div>';
            html += '<div class="lineup-modal-day-label subheading-font' + laSubUpper + '">' + laEscapeHtml(dayLabel) + '</div>';
            html += '<div class="lineup-modal-artist-grid body-font">';
            for (var a = 0; a < artists.length; a++) {
              html += '<span>' + laEscapeHtml(artists[a]) + '</span>';
            }
            html += '</div>';
            html += '</div>';
          }
          html += '</div>';
        }
      } catch(e) {}
    }

    /* Recap video */
    if (recapVideo) {
      var videoId = laExtractYouTubeId(recapVideo);
      if (videoId) {
        html += '<div class="lineup-modal-video"><iframe src="https://www.youtube.com/embed/' + laEscapeHtml(videoId) + '" allowfullscreen loading="lazy"></iframe></div>';
      }
    }

    laModalDetails.innerHTML = html;

    /* Action button */
    if (lineupUrl) {
      laModalAction.innerHTML = '<a href="' + laEscapeHtml(lineupUrl) + '" class="lineup-modal-link ' + laMainBtnClass + '">' + laBtnLabel('View Full Lineup') + '</a>';
    } else {
      laModalAction.innerHTML = '';
    }

    laPrevBtn.style.visibility = laCurrentIndex === 0 ? 'hidden' : 'visible';
    laNextBtn.style.visibility = laCurrentIndex === laCurrentCards.length - 1 ? 'hidden' : 'visible';
  }

  function laCloseModal() {
    laModal.classList.remove('active');
    document.body.style.overflow = '';
    laModalImg.src = '';
  }

  laCloseBtn.addEventListener('click', laCloseModal);
  laModal.addEventListener('click', function(e) {
    if (e.target === laModal || e.target.classList.contains('lineup-modal-nav-wrapper')) laCloseModal();
  });
  laPrevBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (laCurrentIndex > 0) { laCurrentIndex--; laRenderModal(); }
  });
  laNextBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    if (laCurrentIndex < laCurrentCards.length - 1) { laCurrentIndex++; laRenderModal(); }
  });
  document.addEventListener('keydown', function(e) {
    if (!laModal.classList.contains('active')) return;
    if (e.key === 'Escape') laCloseModal();
    if (e.key === 'ArrowLeft' && laCurrentIndex > 0) { laCurrentIndex--; laRenderModal(); }
    if (e.key === 'ArrowRight' && laCurrentIndex < laCurrentCards.length - 1) { laCurrentIndex++; laRenderModal(); }
  });

  laSection.addEventListener('click', function(e) {
    var btn = e.target.closest('.open-bio-modal');
    if (!btn) return;
    var card = btn.closest('.lineup-card');
    if (!card) return;
    var container = card.closest('.lineup-gallery__filtered-grid') || card.closest('.lineup-gallery__grid');
    if (!container) return;
    var visibleCards = container.querySelectorAll('.lineup-card:not(.la-hidden)');
    var idx = Array.from(visibleCards).indexOf(card);
    laOpenModal(visibleCards, idx);
  });

  /* -- Auto-apply filters from URL params (cross-link from poster gallery) -- */
  (function() {
    var params = new URLSearchParams(window.location.search);
    var urlYear = params.get('year');
    var urlEvent = params.get('event');
    if (!urlYear && !urlEvent) return;

    if (laFeatured) laFeatured.style.display = 'none';
    laPanels.forEach(function(p) { p.style.display = 'none'; });

    var changed = false;

    if (urlYear) {
      laFilterYear.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        if (cb.value === urlYear) { cb.checked = true; changed = true; }
      });
      updateTriggerLabel(laFilterYear, laFilterYear.getAttribute('data-label'));
    }

    if (urlEvent) {
      laFilterEvent.querySelectorAll('input[type="checkbox"]').forEach(function(cb) {
        if (cb.value === urlEvent) { cb.checked = true; changed = true; }
      });
      updateTriggerLabel(laFilterEvent, laFilterEvent.getAttribute('data-label'));
    }

    if (changed) {
      laFilterDrawer.classList.add('open');
      laFilterToggle.classList.add('active');
      laApplyFilters();
      if (window.history.replaceState) {
        var cleanUrl = window.location.pathname;
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  })();
}
